import { SiGithub, SiLinkedin } from "react-icons/si";

export default function Footer() {
  return (
    <footer className="mt-auto w-full py-8 text-sm text-slate-500 dark:text-slate-400 px-6 md:px-10 lg:px-0">
      <div className="max-w-4xl mx-auto flex items-center justify-between">
        <div>© {new Date().getFullYear()} Jaime Gimillo</div>
        <div className="flex items-center gap-4">
          <a href="https://github.com/jgimillo" className="inline-flex items-center gap-2">
            <SiGithub size={14} /> GitHub
          </a>
          <a href="https://www.linkedin.com/in/jaime-gimillo" className="inline-flex items-center gap-2">
            <SiLinkedin size={14} /> LinkedIn
          </a>
        </div>
      </div>
    </footer>
  )
}

